import { render, staticRenderFns } from "./ChallengeAdd.vue?vue&type=template&id=611db973&scoped=true"
import script from "./ChallengeAdd.vue?vue&type=script&lang=js"
export * from "./ChallengeAdd.vue?vue&type=script&lang=js"
import style0 from "./ChallengeAdd.vue?vue&type=style&index=0&id=611db973&prod&lang=scss"
import style1 from "./ChallengeAdd.vue?vue&type=style&index=1&id=611db973&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611db973",
  null
  
)

export default component.exports